import {connect} from '@modifi/redux'
import {COMPANY_FOUNDATION_DATE} from '@modifi/plugin-onboarding'

import CompanyIntroductionFormContent, {
  CompanyIntroductionFormContentProps,
} from './CompanyIntroductionFormContent'
import {
  aEnsureLegalFormsByCountryCode,
  selectLegalFormsAreLoadingForCountry,
  selectLegalFormsByCountryCode,
} from '../../../../../data/legal-forms'
import {
  selectCompanyAddress,
  selectCompanyExternalId,
  selectCompanyIsLocked,
  selectCurrentCompaniesCountryCode,
} from '../../../../../data/company'
import {
  aEnsureFetchIndustries,
  selectIndustriesAreLoading,
  selectIndustryList,
} from '../../../../../data/industries'
import {
  aEnsureCompanyRegistrationByExternalId,
  selectCompanyCinCode,
} from '../../../../../data/company-registration'
import {
  selectPublicRegisteredCompaniesAreLoading,
  selectPublicRegisteredCompaniesRetrievalStatus,
} from '../../../../../data/public-registered-companies'
import {selectInputFieldByName} from '../../../../../data/input-fields'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  CompanyIntroductionFormContentProps,
  | 'isLoading'
  | 'externalCompanyId'
  | 'retrievalStatus'
  | 'countryCode'
  | 'hasCompanyCinCode'
  | 'legalFormOptions'
  | 'industryOptions'
  | 'hasFoundationDateInputField'
  | 'isCompanyLocked'
  | 'companyAddress'
> => {
  const countryCode = selectCurrentCompaniesCountryCode(state) || ''
  const externalCompanyId = selectCompanyExternalId(state) || ''
  return {
    isLoading:
      selectPublicRegisteredCompaniesAreLoading(state) ||
      selectLegalFormsAreLoadingForCountry(state, countryCode) ||
      selectIndustriesAreLoading(state),
    externalCompanyId,
    retrievalStatus: selectPublicRegisteredCompaniesRetrievalStatus(state),
    countryCode,
    hasCompanyCinCode: !!selectCompanyCinCode(state),
    legalFormOptions: countryCode ? selectLegalFormsByCountryCode(state, countryCode) : [],
    industryOptions: selectIndustryList(state),
    hasFoundationDateInputField: selectInputFieldByName(
      state,
      COMPANY_FOUNDATION_DATE
    ) as unknown as boolean,
    isCompanyLocked: selectCompanyIsLocked(state),
    companyAddress: selectCompanyAddress(state),
  }
}

const mapDispatchToProps = {
  fetchLegalForms: aEnsureLegalFormsByCountryCode,
  fetchIndustries: aEnsureFetchIndustries,
  fetchCompanyRegistration: aEnsureCompanyRegistrationByExternalId,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyIntroductionFormContent)
